import { type Theme, css } from "@emotion/react";
import { typography } from "aviary-tokens";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const profileToggle = css`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  max-height: 100%;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: ${dimensions.phoneLargeMax}) and (min-height: 568px) {
    padding-top: 1rem;
  }
`;

export const profileToggleLink = (theme: Theme) => css`
  padding: 1rem 1.5rem 1.25rem 1.5rem;
  text-decoration: none;
  font-weight: ${typography.weightBase};
  color: ${theme.text.body};

  :hover {
    text-decoration: none;
    color: ${theme.text.body};
  }
`;

export const stopImpersonatingLink = css`
  padding: 1rem 1.5rem 1.25rem 1.5rem;
`;
export const logo = css`
  display: block;
  height: 2.7rem;
`;

export const mobileNavWrapper = css`
  display: flex;
  width: calc(100% - 1rem);
`;

export const rsoButton = (theme: Theme) => css`
  margin: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 0.5rem;
  gap: 0.125rem;
  border-radius: 0.5rem;
  border: 1px ${theme.system.borderBase} solid;
`;
